site.megamenu = {
	init:function() {
		//Wrap mmLevel2 for megamenu reasons
		$('.mmLevel2', '#mainmenu').wrap('<div class="megamenu"><div class="contentWrap"></div></div>');
		$('.megamenu .level2>a span').wrap('<span>');

		$('.level1.children > a','#mainmenu').on('click', function (e) {
			if ($(document).width()+15 >= 992) {
				e.preventDefault();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					$('body').addClass('megamenu-open');
					$('.level1.open', '#mainmenu').removeClass('open');
					$(this).parent().addClass('open');
				}

				$('body.megamenu-open').on('click', function (e) {
					if (!$(e.target).parents('#mainmenu').length) {
						site.megamenu.close();
					}
				});
			}
		});

		site.megamenu.sidebarMenu();
	},

	close:function() {
		$('body').removeClass('megamenu-open');
		$('.level1.open', '#mainmenu').removeClass('open');
	},
	sidebarMenu: function() {
		var $sidebarMenu = $('#mainmenu2', '#sidebar');
		$('.children', $sidebarMenu).prepend('<span class="expand"></span>');
		$('.selectedLevel2', $sidebarMenu).addClass('down');
		$('.selectedLevel3', $sidebarMenu).addClass('down');
		$('.selectedLevel4', $sidebarMenu).addClass('down');
		$('.expand', $sidebarMenu).bind('click', function(e) {
			e.preventDefault();
			$(this).closest('li').toggleClass('down');
		});
	}
};
